import React from "react";
import { array, string } from "prop-types";

import TwoStoryWithAd from "../two-story-with-ad";
import FourHorizontalStory from "../four-horizontal-story";
import ThreeStory from "../three-story";
import SixStoryMixedDesignMobile from "../six-story-mixed-design-mobile";
import { Standard337x280Container } from "../ad-free";

import "./twelveStoryMixedDesign.m.css";

const TwelveStoryMixedDesign = ({ list, className }) => {
  const getDesktopView = () => {
    const stories = [...list];

    const firstSetStories = stories.splice(0, 2);
    const secondSetStories = stories.splice(0, 4);
    const thirdSetFirstStories = stories.splice(0, 1);
    const fourthSetFirstStories = stories.splice(0, 1);
    const thirdSetOtherTwoStories = stories.splice(0, 2);
    const fourthSetOtherTwoStories = stories.splice(0, 2);
    const thirdSetStories = [...thirdSetFirstStories, ...thirdSetOtherTwoStories];
    const fourthSetStories = [...fourthSetFirstStories, ...fourthSetOtherTwoStories];

    return (
      <div styleName="desktop-view">
        <TwoStoryWithAd list={firstSetStories} />

        {secondSetStories.length ? <FourHorizontalStory list={secondSetStories} /> : null}

        {thirdSetStories.length ? (
          <div styleName="three-story-view">
            {thirdSetStories.length ? <ThreeStory list={thirdSetStories} /> : null}
            {fourthSetStories.length ? <ThreeStory list={fourthSetStories} /> : null}
          </div>
        ) : null}
      </div>
    );
  };

  const getMobileView = () => {
    const stories = [...list];

    const firstSetStories = stories.splice(0, 6);
    const secondSetStories = stories.splice(0, 6);

    return (
      <div styleName="mobile-view">
        {firstSetStories.length ? <SixStoryMixedDesignMobile list={firstSetStories} /> : null}
        <Standard337x280Container id="mid2" type="mobile" />
        {secondSetStories.length ? <SixStoryMixedDesignMobile list={secondSetStories} /> : null}
      </div>
    );
  };

  return (
    <div styleName="wrapper" className={className}>
      {getDesktopView()}
      {getMobileView()}
    </div>
  );
};

TwelveStoryMixedDesign.defaultProps = {
  className: "",
};

TwelveStoryMixedDesign.propTypes = {
  list: array.isRequired,
  className: string,
};

export default TwelveStoryMixedDesign;
